module.exports = __webpack_public_path__ + "img/plans1.1263344f.jpg";